import { FC } from "react";
import { NativeProps } from "@/utils/components-utils";
import { useTranslation } from "next-i18next";
import { clsx } from 'clsx'

export type SelectedItem = {
	label: string;
	value: string;
	acronym?: string;
	disabled?: boolean;
};
type Props = {
	onSelected: (value: SelectedItem) => void;
	list: SelectedItem[];
	renderOption?: (option: SelectedItem) => React.ReactNode;
} & NativeProps;

export const SelectView: FC<Props> = ({ onSelected, list, renderOption }) => {
	const { t } = useTranslation("common");
	return (
		<ul className="hidden-scroll-bar h-[70vh] md:h-[320px] overflow-y-auto px-3 pb-4 text-sm inter-text select-none">
			{list.map((item, index) => {
				return (
					<li
						key={index}
						onClick={(e) => {
							if (item.disabled) return
							onSelected(item);
						}}
						className={clsx(
							'px-4 py-3 f2_19_bottom_50 rounded-md mb-1',
							item.disabled ? 'text-c3c3c3 dark:text-[#2C2C2C] cursor-not-allowed' : 'active:font-bold dark:active:text-white active:text-dark hover:bg-gray-100 dark:hover:bg-[#1a1a1a] cursor-pointer'
						)}
					>
						{renderOption ? renderOption(item) : item.label}
					</li>
				);
			})}

			{list.length === 0 && <p className="mt-4 text-center">{t("nothing-here")}</p>}
		</ul>
	);
};
